// extracted by mini-css-extract-plugin
export var button = "_m5-2";
export var card = "_m5-0";
export var closeButtonContainer = "_m5-3";
export var iconContainer = "_m5-1";